export default "__VITE_ASSET___DNjEvF4__"